var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F89521"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.036 8.101c-1.052-.89-2.127-1.6-3.196-2.112-1.365-.654-2.725-.986-4.043-.986-1.317 0-2.677.332-4.042.986-1.069.512-2.144 1.223-3.196 2.112-1.775 1.502-2.87 2.99-2.916 3.052-.19.26-.19.614 0 .875.046.062 1.14 1.55 2.916 3.052 1.052.889 2.127 1.6 3.196 2.112 1.365.654 2.725.986 4.042.986 1.317 0 2.678-.332 4.043-.986 1.069-.513 2.144-1.223 3.196-2.112 1.775-1.502 2.87-2.99 2.916-3.052.19-.26.19-.615 0-.875-.046-.063-1.14-1.55-2.916-3.052zm-7.239 8.594c-4.024 0-7.522-3.795-8.609-5.105 1.087-1.31 4.586-5.104 8.61-5.104 4.023 0 7.521 3.794 8.609 5.104-1.088 1.31-4.586 5.105-8.61 5.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.797 7.842c-2.066 0-3.748 1.682-3.748 3.748 0 2.067 1.682 3.749 3.748 3.749 2.067 0 3.749-1.682 3.749-3.749 0-2.066-1.682-3.748-3.749-3.748zm0 6.014c-1.249 0-2.265-1.016-2.265-2.266 0-1.249 1.016-2.265 2.265-2.265 1.25 0 2.266 1.016 2.266 2.265 0 1.25-1.016 2.266-2.266 2.266z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.d18d967779e6029187febf999f4b9655.svg";
export { ForwardRef as ReactComponent };